<template>
  <b-row>
    <b-col md="4">
      <b-card-normal title="Tag Tanımlama" :showLoading="show">
        <template v-slot:body>
          <tanimlama :taglar="taglar" @showLoading="show = $event" @refresh="handlerGetData" :updateData="updateData" />
        </template>
      </b-card-normal>
    </b-col>
    <b-col md="8" order-sm="12">
      <b-card-normal title="Taglar" :showLoading="show">
        <template v-slot:body>
          <list :data="rows" @update="handlerUpdate($event)" @refresh="handlerGetData" />
        </template>
      </b-card-normal>
    </b-col>
  </b-row>
</template>

<script>
import BCardNormal from '@core/components/b-card-actions/BCardNormal.vue';
import Tanimlama from './component/tanimlama.vue';
import List from './component/list.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    BCardNormal,
    Tanimlama,
    List,
  },
  data: () => ({
    show: false,
    taglar: [],
    rows: [],
    updateData: {},
  }),
  computed: {
    ...mapGetters(['getTaglar']),
  },
  async created() {
    this.handlerGetData();
  },
  methods: {
    async handlerGetData() {
      this.show = true;
      this.rows = [];
      this.taglar = [];

      await this.$store.dispatch('tagListele');
      const taglar = await this.getTaglar;

      taglar.forEach((el) => {
        this.rows.push({ ...el });
      });
      this.show = false;
    },
    handlerUpdate(event) {
      this.updateData = event;
    },
  },
};
</script>

<style lang="scss" scoped></style>
